import { LEGAL_REPRESENTATIVE_ATTR } from "../../../models/product";
import { getProductAttributeByCode } from "./getProductAttributeByCode";
import { GetProductAttributeBooleanValue } from "./types";

export const getSupportsLegalRepresentative: GetProductAttributeBooleanValue = offer => {
  if (!offer) return false;

  const attr = getProductAttributeByCode(offer, LEGAL_REPRESENTATIVE_ATTR);
  return attr && attr.value.type;
};
